import { Flex, Heading } from '@chakra-ui/react';
import { memo } from 'react';
import { colors } from 'theme/colors';
import { Link } from '../styles';

interface IHeaderDefault {
  titleAllCard: string;
  text: string;
  href: string;
}

const HeaderDefaultAllFunctions: React.FC<IHeaderDefault> = ({ titleAllCard, text, href }) => {
  return (
    <Flex justifyContent={'space-between'} alignItems={'center'} padding={1} mb="1em">
      <Heading as="h3" fontWeight={'bold'} fontSize="20px">
        {titleAllCard}
      </Heading>
      <Link color={colors.brand.tertiary} href={href}>
        {text}
      </Link>
    </Flex>
  );
};

export const HeaderDefault = memo(HeaderDefaultAllFunctions);
